export const formatNumberWithSpaces = (value, decimalPlaces = 2) => {
  if (!value) return "";
  const stringValue = typeof value === "string" ? value : String(value);
  const numericValue = stringValue.replace(/[^\d.,]/g, "");

  return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};
export function removeSpaces(value) {
  return String(value)
    .replace(/[^0-9.,]/g, "")
    .replace(/\s+/g, "")
    .replace(",", ".");
}

export function numberWithSpacesIntl(number) {
  return new Intl.NumberFormat("fr-FR").format(number);
}
